import { render } from "./clue.vue?vue&type=template&id=08acbdf0&scoped=true"
import script from "./clue.vue?vue&type=script&lang=js"
export * from "./clue.vue?vue&type=script&lang=js"

import "./clue.vue?vue&type=style&index=0&id=08acbdf0&scoped=true&lang=css"
import "./clue.vue?vue&type=style&index=1&id=08acbdf0&lang=css"
script.render = render
script.__scopeId = "data-v-08acbdf0"

export default script